export default "__VITE_ASSET__eMsRrhoy__"